import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal'
import Notifications from '@kyvg/vue3-notification'
import App from './components/PresentsCont.vue'

const vfm = createVfm()

export const initPresents = () => {
    const el = document.getElementById('product-presents');

    const items = window.productPresents || [];

    if (!el || !items.length) return;

    const app = createApp(App, { items });

    app
        .use(vfm)
        .use(Notifications)
        .mount(el);
};


